/*
 * @prettier
 * @copyright (c) 2019 - present, HGC-AB
 * @licence This source code is licensed under the MIT license described and found in the
 * LICENSE file in the root directory of this source tree.
 */
import { useStaticQuery, graphql } from 'gatsby'

/**
 * Query tags by articles and return them as a flat array
  */
export default function useTagsByArticles() {
  const { allMarkdownRemark } = useStaticQuery(graphql`
    query allTagsByArticles {
      allMarkdownRemark(
          filter: { 
              fileAbsolutePath: { regex: "/(articles)/.*\\.md$/" }
              frontmatter: { published: { ne: "No" } }
          }
      ) {
        group(field: frontmatter___tags) {
          tag: fieldValue
        }
      }
    }
  `)

  /**
   * Return a flat array of tags
   */
  return allMarkdownRemark.group.map(tag => tag.tag)
}
